export interface NavItem {
  to: string;
  label: string;
  end: boolean;
}

export const navItems: NavItem[] = [
  { to: '/', label: 'Census', end: true },
  { to: '/map', label: 'World Map', end: false },
  { to: '/countries', label: 'Countries', end: false },
  { to: '/builders', label: 'Builders', end: false },
  { to: '/models', label: 'Models', end: false },
  { to: '/platforms', label: 'Platforms', end: false },
  { to: '/code', label: 'Code', end: false },
  { to: '/latest', label: 'Latest', end: false },
];

export const moreNavItems: NavItem[] = [
  { to: '/networks', label: 'Networks', end: false },
  { to: '/directories', label: 'Directories', end: false },
  { to: '/discovery', label: 'Discovery', end: false },
  { to: '/parity', label: 'Parity', end: false },
  { to: '/compare', label: 'Compare', end: false },
  { to: '/changelog', label: 'Bulletin', end: false },
  { to: '/api', label: 'API & data', end: false },
  { to: '/methodology', label: 'Methodology', end: false },
];

export const allNavItems: NavItem[] = [...navItems, ...moreNavItems];
